var _circle, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickerWallpaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 76,
    viewBox: "0 0 73 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 30,
    r: 30,
    fill: "#DDE0FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 64,
    height: 63,
    fill: "url(#pattern0_1419_34390)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1419_34390",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1419_34390",
    transform: "scale(0.015625 0.015873)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1419_34390",
    width: 64,
    height: 63,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA/CAYAAABQHc7KAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAQKADAAQAAAABAAAAPwAAAAA90zWuAAAEO0lEQVRoBe1aO28TQRAe3/nB+YiJsZSksFIgkoKHUtCAxEPi8QPyA5CoKSgREg0dVSR6GkpKCqhQoCFSJBBC0EGDokBCBHmYOCF24rBzx5C99d3t3l6ci+1b6bSzO/Ptzn77uJ2zAdKUMpAykDKQMpAykDLQrwxkZAN/+2ysNpH9MiCzE/VbWwBzKzb8rJyAC7lPolpadvDLFpxefgowPCy1DzB4A7fOXwrQOdVGmBJ1OoNHXKHAnkZda/D/8c1NAGRCP12UQaUEyBrodn3fE5DVncFWC2BpyUUPDQEYEamMi9f1W8RFdHsPvrIC0Gi4D8pRU1x81P6C7LUJ2GTnEyVepjpZzmN4WYbbb702AfvtSFLtKZ8BuGdx2dJs7bIyJZTn592SZQGUy+1nQhx81fgBU/YjuJadhWzThHXrClhnH4BZGiMXgvPV1TWmnDYM416pVPosGiqvADzw6nUAHAg+u1xLKFM92tDhyJk4dTr4au4XvBu8CZOF11AyN6F4ZB0qOy/g96sb0Nr4xncRJJeYYrLVas3WarVx0UiZABF4UOWp6hM4btQ83ZnM68HiKtTf3/fUSwplRsJD0UaZAHzV2ba7tPGVx9+hUcY6fOyjAGgrJl389WMfxaacMt40GwvTvrqQyquiTvkMwMFVKntw3PN0DmSYrlrd0/lJuvgBg3vdCA1nTMZCtMTPm4NkrndnwhAhN3w5qvMvRYA2AXjaU7KKJKnncfFr7Gwvnrmr3GEmk/mey+XuiABtAvBVl8+7T3lQbFZejos3Tfbm2VqWdwTwlRk9Nk3znG3bCyKgbU+IBo3nnjeeqA4tz80BjI6GmoQq9wN/8rbnvG7rT3sFtLXUpRVSAhYX3UtO1PHhxQixSeNlfksJwIgviWgvbrRI+NgEYAN0/5c1xut5DC/zNmEyj+HlMAyvU8VIVwDfaC/KSjfBTkd7SCyeGZ2KNsMmTo0A1gJdezGiazYBRka8zWIEiOeFX8JoMUm8n09U1/dbQImATkZ7NBO60aIKnmz8cqUtoBvtUYdJ48kPv1xpBfgBe6VOiYAkor240SKPD5ssKQEY8WlHe+x7RdL4sMGjTnoGiK87WYOkxy9AI+xH3aTx5E9QLl0BQcBeqZeugKCB4s2NPn/jKwxnPEpKGk++RnSbYO61NcnfBina041WaSTaBPDRFi9Tw7Kcx/CyDEd6HsPLpFfNtQlQ7eCw2ymfAZ2M1g4i2gyaCGUCDnO0pxJtBhHQ91tAmYBORmsHEW0GrQDlLaD72x51nDSe/BBz5RUgAnulrE0AH211Y7RIE6i8BQhAOf62h98GMelGi0niXc8VokEyFHMn2hM+jIo2YeWk8eSb9hagBro9TwmQzeCHnXHvP5RkgH96/AfHn7wNM9sTigivmYPPFmFm45RXoVhCfDNvbSuap2YpAykDKQMpAykD/cjAX3Tt4Ta411TMAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerWallpaper);
export default __webpack_public_path__ + "static/media/sticker-wallpaper.449d170afb246eb23eeeaf1a010dd1dd.svg";
export { ForwardRef as ReactComponent };